export enum RoleEnum {
  SUPERADMIN,
  ADMIN,
  SUPERADMIN_EMPLOYEE,
  ADMIN_EMPLOYEE,
  COACH
}
